'use strict';

const angular = require('angular');

import { ISeason } from '../../interfaces';

export class AdminSeasonExtrasComponent{
  season: ISeason;
  $http: ng.IHttpService;

  extras: Object[];  

  extraIntroductionFr: string = "";
  extraIntroductionEn: string = "";
  extraLinkTextFr: string = "";
  extraLinkTextEn: string = "";
  extraLinkFr: string = "";
  extraLinkEn: string = "";

  newName: String = "";
  newNote: String = "";
  newUnit: String = "";
  newProducer: String = "";
  newDescription: String = "";

  newNameFR: String = "";
  newNoteFR: String = "";
  newUnitFR: String = "";
  newProducerFR: String = "";
  newDescriptionFR: String = "";

  newPrice: Number = 0;
  newDeadline: Date = null;

  currentlyEditing = null;

  /*ngInjector*/
  constructor($http, $scope) {
    this.$http = $http;
  }

  saveIntroduction() {
    this.season.extraIntroductionFr = this.extraIntroductionFr;
    this.season.extraIntroductionEn = this.extraIntroductionEn;
    
    this.season.extraLinkTextFr = this.extraLinkTextFr;
    this.season.extraLinkTextEn = this.extraLinkTextEn;
    this.season.extraLinkFr = this.extraLinkFr;
    this.season.extraLinkEn = this.extraLinkEn;
    
    this.save(() => {
      this.currentlyEditing = null;
      this.reset();
    });
  }

  canCreateExtra(extra) {
    let value = extra;
    if (!value) {
      value = {
        name: this.newName,
        unit: this.newUnit,
        producer: this.newProducer,
        description: this.newDescription,
        price: this.newPrice
      }
    }
    return value.name != "" && value.producer != "" && value.price>0 && value.unit!="";
  }
  createExtra() {
    if (!this.season.hasOwnProperty('availableExtras')) {
      this.season.availableExtras = [];
    }

    let extraEN = {
      name: this.newName,
      //note: this.newNote,
      unit: this.newUnit,
      producer: this.newProducer,
      description: this.newDescription
    };

    let extraFR = {
      name: this.newNameFR,
      //note: this.newNoteFR,
      unit: this.newUnitFR,
      producer: this.newProducerFR,
      description: this.newDescriptionFR
    };

    this.season.availableExtras.push({
      /* name: this.newName,
      note: this.newNote,
      unit: this.newUnit, */
      extraBases: [extraEN, extraFR],
      price: this.newPrice && this.newPrice!==null ? this.newPrice : 0,
      deadline: this.newDeadline
    } as any);
    this.save(() => {
      this.currentlyEditing = null;
      this.reset();
    });
  }

  reset() {
    this.newName = "";
    this.newNote = "";
    this.newUnit = "";
    this.newProducer = "";
    this.newDescription = "";

    this.newNameFR = "";
    this.newNoteFR = "";
    this.newUnitFR = "";
    this.newProducerFR = "";
    this.newDescriptionFR = "";

    this.newPrice = 0;
    this.newDeadline = new Date();
  }

  $onInit() {
    let scope = this;
    let resolve = (this as any).resolve;
    if (_.has(resolve, 'season') && resolve.season !== null) {
      scope.season = resolve.season;
      scope.extraIntroductionFr = scope.season.extraIntroductionFr;
      scope.extraIntroductionEn = scope.season.extraIntroductionEn;
      scope.extraLinkTextFr = scope.season.extraLinkTextFr;
      scope.extraLinkTextEn = scope.season.extraLinkTextEn;
      scope.extraLinkFr = scope.season.extraLinkFr;
      scope.extraLinkEn = scope.season.extraLinkEn;
    } else {
      // Season is required!
      this.cancel();
    }
  }

  startEditingExtra(extra) {
    this.currentlyEditing = _.cloneDeep(extra);
  }

  deleteExtra(extra) {
    if (confirm("Are you sure to delete the extra! The extra cannot be recover.")) {
      this.season.availableExtras = _.without(this.season.availableExtras, extra);
      this.save(() => {});
    }
  }

  saveEditedExtra(modifiedExtra, extra) {
    /* extra.name = modifiedExtra.name;
    extra.note = modifiedExtra.note;
    extra.unit = modifiedExtra.unit; */
    extra.extraBases[0] = modifiedExtra.extraBases[0];
    extra.extraBases[1] = modifiedExtra.extraBases[1];
    extra.price = modifiedExtra.price;
    extra.deadline = modifiedExtra.deadline;
    
    this.save(() => {
      this.currentlyEditing = null;
    });
  }

  save(cb) {
    this.$http.put('/api/seasons/'+this.season._id, this.season)
    .then((result) => {
      this.season = result.data as ISeason;
      if (cb) {
        cb();
      }
    })
  }

  ok() {
    (this as any).close({$value: this.season});
  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };
}


export default angular.module('terrappApp.adminSeasons')
  .component('adminSeasonExtras', {
    template: require('./adminSeasonExtras.html'),
    controller: AdminSeasonExtrasComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/admin/adminSeasons/adminSeasonExtras.component.ts